import React from "react";
import { QueryLoader, RetryError } from "@jsq/ds/core";
import { Redirect, useLocation, useParams } from "react-router-dom";
import { useGetIsOnboardingRequiredForArenaQuery } from "common/types/mainHooks";
import { type PortalRouteParams } from "apps/portal/Portal/SingleManager/types";
import { resultHasErrorWithErrorCode } from "common/utils/errors";
import { NoBatching } from "common/constants/NoBatching";

interface Props {
  children: React.ReactNode;
}

const OnboardingRequiredProtectedRoute = ({ children }: Props) => {
  const { arenaDomain } = useParams<PortalRouteParams>();
  const location = useLocation();
  const result = useGetIsOnboardingRequiredForArenaQuery({
    variables: {
      arenaDomain,
    },
    context: NoBatching,
  });

  const searchParams = new URLSearchParams(location.search);
  searchParams.append("arena", arenaDomain);
  searchParams.append("path", location.pathname);

  const renderUnauthenticatedDataRoom = () => {
    /**
     * This handles a special case for when a non-authenticated user
     * is viewing a dataroom but the dataroom does not require authentication.
     */
    if (resultHasErrorWithErrorCode(result, "SINGLE_OR_GLOBAL_POR_USER_NOT_FOUND")) {
      return <>{children}</>;
    }

    return <RetryError result={result} />;
  };

  return (
    <QueryLoader result={result} renderError={renderUnauthenticatedDataRoom}>
      {result.data?.currentGlobalUser?.isOnboardingRequired ? (
        <Redirect to={`/i/${arenaDomain}/onboarding?${searchParams}`} />
      ) : (
        <>{children}</>
      )}
    </QueryLoader>
  );
};

export default OnboardingRequiredProtectedRoute;
